import { useEffect, useRef, useState } from "react";
import GlobalEvent, { useEvent} from 'js-events-listener/react';
import { useNavFunc } from 'navigation';
import Store from 'store';
import shallow from "zustand/shallow";
import { SCREEN } from "const";

export const AIGetNavigation = () => {
  const { navigate } = useNavFunc();
  // @ts-ignore
  window.navigate = navigate;
  console.log('navigate updated');
  return null;
}

export const AIAssistantChatBox = () => {

  // @ts-ignore
  const [show] = useState(window.useAIAssistant || !!localStorage.getItem('useAIAssistant'));

  const { loading, learner, editLearner, saveLearner, error, restoreLearner } = Store.useLearnerStore(state => ({
    token: state.token,
    learner: state.learner,
    editLearner: state.editLearner,
    saveLearner: state.saveLearner,
    restoreLearner: state.restoreLearner,
    loading: state.loading,
    error: state.error,
  }), shallow);

  useEffect(() => {
    GlobalEvent.emit("AI.receiveLearner", { learner });
  }, [learner]);

  const learnerRef = useRef(learner);
  const learnerTimeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    learnerRef.current = learner;
  }, [learner]);

  useEvent("AI.editLearner", ({ firstName, lastName, email }: { firstName: string, lastName: string, email: string }) => {
    console.log('AI.editLearner', firstName, lastName, email);
    if (firstName) {
      editLearner('firstName', firstName);
    }
    if (lastName) {
      editLearner('lastName', lastName);
    }
    if (email) {
      editLearner('email', email);
    }
    // if (!!firstName && !!lastName && !!email) {
    //   // @ts-ignore
    //   saveLearner(window.pathfinderId);
    // }
    clearTimeout(learnerTimeoutRef.current);
    learnerTimeoutRef.current = setTimeout(() => {
      if (!!learnerRef.current.firstName && !!learnerRef.current.lastName && !!learnerRef.current.email) {
        // @ts-ignore
        saveLearner(window.pathfinderId);
      }
    }, 1000);
  }, []);

  useEvent("AI.goTo", (screen: string) => {
    // @ts-ignore
    window.navigate(screen);
  }, []);

  useEffect(() => {
    if (!show) return;
    // @ts-ignore
    window.GlobalEvent = GlobalEvent;
    // @ts-ignore
    window.useEvent = useEvent;
    const script = document.createElement('script');
    script.src = '/ai-assisstant/loader.js?v=0.0.1';
    document.body.appendChild(script);
  }, [show]);

  return null;
};

// @ts-ignore
window.useAIAssistant = window.location.href.includes('ai_assistant=1');
// @ts-ignore
if (window.useAIAssistant) {
  localStorage.setItem('useAIAssistant', 'true');
}